<textarea
  class="border resize-none w-full min-w-40 border-zinc-200 px-3 py-2 min-h-[10rem] rounded-lg focus:outline-none focus-within:border-primary-500 placeholder-gray-400"
  [placeholder]="placeholder()"
  [spellcheck]="true"
  [autocomplete]="true"
  [autofocus]="true"
  [readOnly]="readonly()"
  [maxLength]="maxLength() || 524288"
  [ngModel]="value()"
  (ngModelChange)="updateValue($event)"
></textarea>
